module.exports = __webpack_public_path__ + "static/media/StackedBar_CS.01e86707.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/assets/StackedBar_CS.svg
// module id = 289
// module chunks = 0